// @flow
import TeamDetail from 'components/team/teamDetail/TeamDetail';
import { connect } from 'react-redux';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/team/teamDetail/TeamDetail';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state: StateType): StateProps => ({
  title: state.pageListState.title,
  description: state.pageListState.description,
  excerpt: state.pageListState.excerpt,
  label: state.pageListState.label,
  featured_media: state.pageListState.featured_media,
  liste_cards: state.cardState.liste_cards,
  articles: state.newsletterCategoryState.articles,
  status: state.pageListState.status,
  meta_title: state.pageListState.meta_title,
  meta_description: state.pageListState.meta_description,
  ranking: state.rankingState.ranking,
  rankingStatus: state.rankingState.status,
  competitions: state.teamResultState.competitions,
  compte_joueurs: state.pageListState.compte_joueurs,
  sidebar: state.pageListState.sidebar_content,
  template: state.pageListState.template,
  prochaine_rencontre: state.settingsState.prochaine_rencontre,
  structure: state.settingsState.structure,
  teamStats: state.teamResultState.teamStats,
  teamStatsStatus: state.teamResultState.status,
  nextMatches: state.teamCalendarState.nextMatches,
  rejoignez_nous: state.settingsState.rejoignez_nous,
  rejoignez_nous_background: state.settingsState.rejoignez_nous_background,
});

export default withRouter(
  connect(mapStateToProps)(TeamDetail)
);
